import { useEffect } from 'react';
import type { RegistrarPerfilRequest } from '../../api-client/perfiles/perfiles.api';
import PerfilForm from '../../components/perfiles/PerfilForm';
import { usePerfilesStore } from '../../stores/perfiles/perfiles.store';

const AgregarPerfil = () => {
  const { current: perfil, nuevo, registrar } = usePerfilesStore();

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarPerfilRequest) => {
    return registrar(values);
  };

  return <PerfilForm esAgregar={true} perfil={perfil} onSave={handleSave} />;
};

export default AgregarPerfil;
